import "./assessmentInfoCard.css"
const AssessmentInfoCard = ({title,smallTitle, children}) => {

    return (
        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6>{title}</h6> <small className="ms-2 align-self-center">{smallTitle}</small>
            </div>
            <div className="card-body">
                {children}
            </div>
        </div>
    )

}

export default AssessmentInfoCard